import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { paymentTypesService } from "services";
import { FiPlus, FiMoreHorizontal, FiSearch } from "react-icons/fi";
import { Dropdown, FormGroup, FormControl } from "react-bootstrap";
import Layout from "components/Layout";
import Loading from "components/Loading";
import PaymentTypeEdit from "components/PaymentTypes/PaymentTypeEditModal";
import Modal from "components/Modal";
import DataTable from "components/DataTable/DataTable";
import { showModal, hideModal } from "actions/modalActions";
import * as expensesActions from "actions/expensesActions";
import { errorFormating } from "utils/utils";

class PaymentTypes extends Component {
	constructor(props) {
		super(props);

		this.state = {
			searchPaymentType: "",
		};

		this.closeModal = this.closeModal.bind(this);
		this.openNewPaymentTypeModal = this.openNewPaymentTypeModal.bind(this);
		this.openEditPaymentTypeModal = this.openEditPaymentTypeModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.getPaymentTypes = this.getPaymentTypes.bind(this);
	}

	componentDidMount() {
		this.getPaymentTypes();
	}

	handleChangeSearch = (event) => {
		this.setState({ [event.target.id]: event.target.value }, () => {
			this.getPaymentTypes();
		});
	};

	async getPaymentTypes() {
		await this.props.getAllPaymentTypes({ q: this.state.searchPaymentType });
	}

	closeModal() {
		this.props.hideModal();
	}

	openNewPaymentTypeModal() {
		const t = this.props.t;
		this.props.showModal(
			{
				open: true,
				title: t("paymentTypes.new"),
				style: { width: "400px" },
				content: (
					<PaymentTypeEdit
						getPaymentTypes={this.getPaymentTypes}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openEditPaymentTypeModal(payment_type) {
		const t = this.props.t;
		this.props.showModal(
			{
				open: true,
				title: t("paymentTypes.edit"),
				style: { width: "400px" },
				content: (
					<PaymentTypeEdit
						payment_type={payment_type}
						getPaymentTypes={this.getPaymentTypes}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openDeletePaymentTypeModal(idPaymentType) {
		const t = this.props.t;
		this.props.showModal(
			{
				open: true,
				title: t("paymentTypes.delete"),
				style: { width: "400px" },
				message:
					t("paymentTypes.deleteConfirm"),
				deleteAction: () => this.confirmDelete(idPaymentType),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	openAlertModal(message) {
		const t = this.props.t;
		this.props.showModal(
			{
				open: true,
				title: t("common.errorDeleting"),
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	confirmDelete = async (idPaymentType) => {
		const response = await paymentTypesService.remove(idPaymentType);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(textError.id);
		} else {
			this.getPaymentTypes();
			this.closeModal();
		}
	};

	getColumns = () => {
		const t = this.props.t;
		return [
		{
			key: "name",
			header: t("common.name"),
			render: (payment_type) => (
				<button
					className="btn-transparent btn-editable"
					onClick={() => this.openEditPaymentTypeModal(payment_type)}
				>
					{payment_type.name}
				</button>
			),
		},
		{
			key: "description",
			header: t("common.description"),
		},
		{
			key: "enabled",
			header: t("common.active"),
			render: (payment_type) =>
				payment_type.enabled ? (
					<span title={t("common.active")} className="estado estado-si">
						{t("common.active")}
					</span>
				) : (
					<span title={t("common.inactive")} className="estado estado-no">
						{t("common.inactive")}
					</span>
				),
		},
		{
			key: "color",
			header: "",
			sortable: false,
			cellClassName: "td-icon",
			render: (payment_type) => (
				<span
					className="bolita"
					style={{
						backgroundColor: payment_type.background_color || undefined,
						border: payment_type.border_color
							? `2px solid ${payment_type.border_color}`
							: undefined,
					}}
				/>
			),
		},
	];
	};

	getContent = () => {
		const t = this.props.t;
		if (this.props.loading) {
			return <Loading />;
		}

		if (this.props.error) {
			return <div className="no-results">t("paymentTypes.loadError")</div>;
		}

		return (
			<DataTable
				tableClassName="table-categories table-hover"
				columns={this.getColumns()}
				rows={this.props.payment_types}
				rowKey={(row) => row.id}
				emptyMessage={t("paymentTypes.empty")}
				actionsColumn={{
					render: (payment_type) => (
						<Dropdown>
							<Dropdown.Toggle variant="action">
								<FiMoreHorizontal />
							</Dropdown.Toggle>
							<Dropdown.Menu>
								<Dropdown.Item
									as="button"
									onClick={() => this.openEditPaymentTypeModal(payment_type)}
								>
									{t("common.edit")}
								</Dropdown.Item>
								<Dropdown.Item
									as="button"
									onClick={() =>
										this.openDeletePaymentTypeModal(payment_type.id)
									}
								>
									{t("common.delete")}
								</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					),
					className: "td-actions",
				}}
			/>
		);
	};

	render() {
		const { t } = this.props;
		return (
			<>
				<Layout
					className="page-categories"
					context="expenses"
					configSidebar={true}
				>
					<div className="heading">
						<div className="heading-left">
							<h1 className="title">{t("settings.expenses.paymentMethods")}</h1>
						</div>
						<div className="heading-filters">
							<FormGroup
								className="form-group form-search"
								controlId="searchPaymentType"
							>
								<FormControl
									type="text"
									placeholder={t("common.search")}
									value={this.state.searchPaymentType}
									onChange={this.handleChangeSearch}
								/>
								<FiSearch />
							</FormGroup>
						</div>
						<div className="heading-actions">
							<button
								type="button"
								title={t("paymentTypes.new")}
								onClick={this.openNewPaymentTypeModal}
								className="btn btn-new"
							>
								<FiPlus />
							</button>
						</div>
					</div>

					{this.getContent()}
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return reducers.expensesReducer;
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getAllPaymentTypes: (options) =>
		dispatch(expensesActions.getAllPaymentTypes(options)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PaymentTypes));
